import React, { Component } from 'react'

export default class About extends Component {
  constructor(props) {
    super(props);
    this.state = {
      brand: "Ford",
      model: "Mustang",
      color: "red",
      year: 1964
    };
  }
  render() {
    return (
      <div className="container p-3">
        <p>Car:{this.state.brand}</p>
      </div>
    )
  }
}
